<template>
    <div class="col-md-12 breadcrumb-header">
        <ul class="nav">
            <li class="nav-item">
                <a class="nav-link" :class="serviceSelection">
                    <span class="step-number">1</span>
                    <span class="step-name">Service Selection</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="clientDetails">
                    <span class="step-number">2</span>
                    <span class="step-name">Client Details</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="paymentDetails">
                    <span class="step-number">3</span>
                    <span class="step-name">Payment Details</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="documentation">
                    <span class="step-number">4</span>
                    <span class="step-name">Documentation</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="completed">
                    <span class="step-number">5</span>
                    <span class="step-name">Completed</span>
                </a>
            </li>
        </ul>
        <hr />
    </div> <!-- End of breadcrumb -->
</template>


<script>
export default {
    name: "BreadcrumbHeader",
    props: {
        //Number reference to the current step
        step: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {};
    },
    computed: {
        /***********************************************************************
            The breadcrumb will be active on certain steps. The following 
            computed properties will help assign the active class appropriately
        ***********************************************************************/
        
        serviceSelection: function(){
            if((this.step > 0 && this.step <= 7) || (this.step == 14))
            {
                return 'active';
            } 

            return '';
        },

        clientDetails: function(){
            if(this.step == 8 || this.step == 12)
            {
                return 'active';
            } 

            return '';
        },

        paymentDetails: function(){
            if(this.step == 9)
            {
                return 'active';
            } 

            return '';
        },

        documentation: function(){
            if(this.step == 10)
            {
                return 'active';
            } 

            return '';
        },

        completed: function(){
            if(this.step == 11 || this.step == 13)
            {
                return 'active';
            } 

            return '';
        }
    }
};
</script>
